import type { Infer, ParseOptions, Type, ValitaResult } from '@badrap/valita'
import { ValitaError } from '@badrap/valita'

export * as valita from '@badrap/valita'

export const unwrapValitaResult = <T>(result: ValitaResult<T>): T | undefined => {
  if (result.ok) {
    return result.value
  }
  return undefined
}

export function tryParse<T extends Type<any>>(label: string, t: T, val: unknown, options?: ParseOptions): Infer<T> {
  try {
    return t.parse(val, options)
  } catch (e) {
    if (e instanceof ValitaError) {
      throw new TryParseError(`Failed to parse ${label}. ${e.message}`, { cause: e })
    }
    throw e
  }
}

export class TryParseError extends Error {}

export function maybeType<T extends Type<any>>(t: T, val: any): Infer<T> | null {
  const res = t.try(val, { mode: 'passthrough' })
  return res.ok ? res.value : null
}

export function maybeTypeU<T extends Type<any>>(t: T, val: any): Infer<T> | undefined {
  const res = t.try(val, { mode: 'passthrough' })
  return res.ok ? res.value : undefined
}

export function maybeOrDefault<T extends Type<any>, D>(t: T, val: any, def: D): Infer<T> | D {
  const res = t.try(val, { mode: 'passthrough' })
  return res.ok ? res.value : def
}
